export default function Postcard({ data }) {
  const d = data || {
    region: "Japan · 14 Days",
    title: "The Slow Train Through Kyoto, Kanazawa & the Noto Coast",
    seller_name: "AIKO KAWAKAMI",
    price: 18,
    cover_emoji: "🏯",
    cover_gradient: "linear-gradient(135deg,#FBE3DD,#F4C8C0)",
    vol: 47,
  };
  return (
    <div className="pc" data-testid="hero-postcard">
      <div className="pc-top">
        <div>
          <div className="pc-region">{d.region}</div>
          <div className="pc-title">{d.title}</div>
        </div>
        <div className="pc-stamp">
          <div>NIRNO</div>
          <div className="price">₹{d.price}</div>
          <div>INR</div>
        </div>
      </div>
      <div className="pc-img" style={{ background: d.cover_gradient }}>{d.cover_emoji}</div>
      <div className="pc-by">
        <span>by <strong style={{ color: "var(--red)", fontFamily: "var(--mono)", letterSpacing: "1px" }}>{d.seller_name}</strong></span>
        <span className="mono">VOL · {d.vol}</span>
      </div>
    </div>
  );
}
